import React, { Component } from "react";
import $ from "jquery";
import { chapterData } from "../data";
import dayjs from "dayjs";

class Anchorlinks extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $('.q-anchorlinks a[href^="#"]').on("click", function (e) {
      // e.preventDefault();

      var target = this.hash,
        $target = $(target);

      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top - 200,
          },
          200,
          "swing",
          function () {
            window.location.hash = target;
          }
        );
    });
  }

  render() {
    const { activeChapters, nextAppointment } = this.props;

    return (
      <nav id="anchors" className="q-anchorlinks py-3">
        <div className="container">
          <ul className="nav inline d-flex">
            {activeChapters.map((chapter, i) => {
              const currentChapter = chapterData[chapter];
              return (
                <li className="nav-item">
                  <a className="nav-link" href={`#${currentChapter.slug}`}>
                    » {currentChapter.label}
                  </a>
                </li>
              );
            })}

            {dayjs(nextAppointment).year() !== 1 ||
            dayjs(nextAppointment).isValid() ? (
              <li className="nav-item">
                <a className="nav-link" href="#date">
                  » Nächster Termin
                </a>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </nav>
    );
  }
}

export default Anchorlinks;
